/* this file added by Bearer Web Developer  */
import { Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineSeparator } from '@mui/lab';
import styles from './locations.module.scss';
import { useContext } from 'react';
import { ReservedOrderInfoContext } from '../contexts/reservedOrderInfo';
import { useThemeMode } from '../../../../../../states/contexts/theme';

const Locations: React.FC = () => {
    const reservedOrderDetails = useContext(ReservedOrderInfoContext);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.locations} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <Timeline classes={{ root: styles.time_line }}>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content }}>
                    <TimelineSeparator>
                        {
                            theme === 'dark' ?
                                <img src="/origin-dark.svg" alt="origin" /> :
                                <img src="/origin.png" alt="origin" />
                        }
                        <TimelineConnector className={''} />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: styles.timeline_content_root }}>
                        <div className={styles.timeline_content}>
                            <p>{reservedOrderDetails?.origin_address}</p>
                            <span>{reservedOrderDetails?.origin_details}</span>
                        </div>
                    </TimelineContent>
                </TimelineItem>
                <TimelineItem classes={{ missingOppositeContent: styles.missing_opposite_content, root: styles.timelineItem_root }}>
                    <TimelineSeparator >
                        <img src="/destination.png" alt="destination" />
                    </TimelineSeparator>
                    <TimelineContent classes={{ root: styles.timeline_content_root }}>
                        <div className={styles.timeline_content}>
                            <p>{reservedOrderDetails?.destination_address}</p>
                            <span>{reservedOrderDetails?.destination_details}</span>
                        </div>
                    </TimelineContent>
                </TimelineItem>
            </Timeline>
        </div>
    )
}
export default Locations;